import store from "../../index.js";
import { NEW_NOTIFICATION } from "./constants";

export async function errorNotification(message) {
  await store.dispatch(NEW_NOTIFICATION, {
    message,
    priority: "error"
  });
}

export async function successNotification(message) {
  await store.dispatch(NEW_NOTIFICATION, {
    message,
    priority: "success"
  });
}

export async function warningNotification(message) {
  await store.dispatch(NEW_NOTIFICATION, {
    message,
    priority: "warning"
  });
}
